import React from "react";

type Log = {
  type: 'success' | 'error';
  message: string;
}

type Props = {
  logs: Log[];
}

export function TabelaLogGeracao({ logs = [] }: Props) {
  const registrosSucesso = logs.filter((registro) => registro.type == 'success');
  const registrosErro = logs.filter((registro) => registro.type == 'error');

  return (
    <div className="grid-12 margem-superior">
      <table className="grid-12 tab tab--responsiva tab--cabecalho-fixo margem-superior--x-maior">
        <thead>
          <tr>
            <th>{registrosSucesso.length} relatórios criados</th>
          </tr>
        </thead>
        <tbody>
          {registrosSucesso.map((registro, index) => {
            return (
              <tr key={index}>
                <td>{registro.message}</td>
              </tr>
            )
          })}
        </tbody>
      </table>

      {registrosErro.length > 0 && (
        <table className="grid-12 tab tab--responsiva tab--cabecalho-fixo margem-superior--x-maior">
          <thead>
            <tr>
              <th>{registrosErro.length} relatórios não puderam ser criados</th>
            </tr>
          </thead>
          <tbody>
            {registrosErro.map((registro, index) => {
              return (
                <tr key={index}>
                  <td>{registro.message}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      )}
    </div>
  )
}